import {useContext} from 'react';
import MyTicketsAndPasses from './MyAccount/MyTicketsAndPasses';
import Section from './UI/Section';
import {Context} from '../context';

function MobileActivityLog() {
  const {localeText} = useContext(Context);
  return (
    <Section
      heading={localeText(
        'rw_activity_log',
        'Activity Log' /*TODO add to phrase data */
      )}
    >
      <MyTicketsAndPasses expanded={true} />
    </Section>
  );
}

export default MobileActivityLog;
